import React, { useState } from 'react'
import { Button, Modal, ModalHeader, ModalBody, ModalFooter, FormGroup, Label, Input, Row, Col } from 'reactstrap'
import Select from 'react-select'
import DatePicker from 'react-datepicker'
import ChangeLog from './ChangeLog'
import PageHeading from '../Shared/LayoutComponents/PageHeading'

import 'react-datepicker/dist/react-datepicker.css'
import 'react-datepicker/dist/react-datepicker-cssmodules.css'
import './datestyle.css'

const OverrideModalDetails = ({ isOpen, toggle, row, sendOverride, approvalUser }) => {
  const [overrideText, setOverrideText] = useState('')

  const statusOptions = [
    { label: 'Active', value: 0 },
    { label: 'Inactive', value: 1 },
    { label: 'Ignored', value: 2 },
  ]

  let selectedOption = statusOptions.find((s) => s.value === approvalUser.invoiceStatus)
  const [selectedInvoiceStatus, setSelectedInvoiceStatus] = useState(selectedOption)
  const [selectedExcludedStatus, setselectedExcludedStatus] = useState(approvalUser.selectedExcludedAdditions)
  const [excludedAgreement, setExcludedAgreement] = useState(approvalUser.excludedFromAgreement)
  let existingDate
  if (approvalUser.ignoredUntil !== null && approvalUser.ignoredUntil !== undefined) {
    existingDate = new Date(approvalUser.ignoredUntil)
  }

  const [selectedDate, setSelectedDate] = useState(existingDate)

  const handleStatusChange = (selectedOption) => {
    setSelectedInvoiceStatus(selectedOption)
  }

  const handleExclusionChange = (selected) => {
    setselectedExcludedStatus(selected)
  }

  const handleExcludedChange = () => {
    setExcludedAgreement(!excludedAgreement)
  }

  const handleDateChange = (date) => {
    setSelectedDate(date)
  }

  return (
    <Modal size="lg" fade={false} isOpen={isOpen} toggle={toggle}>
      <ModalHeader>
        <PageHeading small>Override Change</PageHeading>
      </ModalHeader>
      <ModalBody>
        <FormGroup>
          <Row>
            <Col sm={3}>
              <b>User</b>
            </Col>
            <Col sm={9}>
              {row.displayName} {row.emailAddress && <span>({row.emailAddress})</span>}
            </Col>
          </Row>
          <Row>
            <Col sm={3}>
              <b>Change Log</b>
            </Col>
            <Col sm={9}>
              <ChangeLog changeLog={row.changeLog} />
            </Col>
          </Row>
        </FormGroup>
        <FormGroup>
          <Row>
            <Col sm={3}>
              <b>Invoice Status</b>
            </Col>
            <Col sm={9}>
              <Select
                key={0}
                isMulti={false}
                isClearable={false}
                options={statusOptions}
                onChange={handleStatusChange}
                value={selectedInvoiceStatus}
              />
            </Col>
          </Row>
        </FormGroup>
        {(approvalUser.invoiceStatus && approvalUser.invoiceStatus === 2) ||
        (selectedInvoiceStatus && selectedInvoiceStatus.value === 2) ? (
          <FormGroup>
            <Row>
              <Col sm={3}>
                <b>Ignore End Date</b>
              </Col>
              <Col sm={9}>
                <DatePicker
                  style={{ paddingTop: '5px' }}
                  className="form-control"
                  dateFormat="dd/MM/yyyy"
                  selected={selectedDate}
                  onChange={handleDateChange}
                />
              </Col>
            </Row>
          </FormGroup>
        ) : null}
        <FormGroup>
          <Row>
            <Col sm={3}>
              <b>Addition Exclusions</b>
            </Col>
            <Col sm={9}>
              <Select
                key={1}
                isMulti={true}
                isClearable={true}
                options={approvalUser.excludedAdditionsUsers}
                onChange={handleExclusionChange}
                value={selectedExcludedStatus}
              />
            </Col>
          </Row>
        </FormGroup>
        <FormGroup>
          <Row>
            <Col sm={3}></Col>
            <Col sm={9}>
              <label key={2}>
                <input type="checkbox" checked={excludedAgreement} onChange={handleExcludedChange} /> Excluded From
                Agreement
              </label>
            </Col>
          </Row>
        </FormGroup>
        <FormGroup>
          <Label for="changeText">
            <b>Override Reason</b>
          </Label>
          <Input
            value={overrideText}
            onChange={(e) => setOverrideText(e.target.value)}
            type="textarea"
            name="text"
            id="changeText"
          />
        </FormGroup>
      </ModalBody>
      <ModalFooter>
        <Button outline color="secondary" onClick={toggle}>
          Cancel
        </Button>{' '}
        <Button
          color="warning"
          onClick={() =>
            sendOverride(overrideText, selectedInvoiceStatus, selectedDate, selectedExcludedStatus, excludedAgreement)
          }
        >
          Override
        </Button>
      </ModalFooter>
    </Modal>
  )
}

export default OverrideModalDetails
